<template>
    <cc-modal :modal="modal" @close="close">
        <div slot="header-actions">
            <div class="row">
                <div class="col actions"></div>
            </div>
        </div>
        <div slot="body" class="container-fluid mb-2">
            <div class="row">
                <div class="toggle-section">
                    <h4 class="toggle-section-title">Atualizar dados</h4>
                    <div class="toggle-options-container">
                        <div class="toggle-option">
                            <label class="toggle-switch">
                                <input v-model="updateDesc" type="checkbox" class="toggle-input" />
                                <span class="toggle-slider"></span>
                            </label>
                            <span class="toggle-label">Descrição</span>
                        </div>
                        <div class="toggle-option">
                            <label class="toggle-switch">
                                <input v-model="updateLastPurchase" type="checkbox" class="toggle-input" />
                                <span class="toggle-slider"></span>
                            </label>
                            <span class="toggle-label">Último Preço</span>
                        </div>
                        <div class="toggle-option">
                            <label class="toggle-switch">
                                <input v-model="updatePacking" type="checkbox" class="toggle-input" />
                                <span class="toggle-slider"></span>
                            </label>
                            <span class="toggle-label">Embalagem</span>
                        </div>
                        <div class="toggle-option">
                            <label class="toggle-switch">
                                <input v-model="updateInternalCode" type="checkbox" class="toggle-input" />
                                <span class="toggle-slider"></span>
                            </label>
                            <span class="toggle-label">Código Interno</span>
                        </div>
                    </div>
                </div>
                <vue-dropzone
                    id="dropzoneFile"
                    ref="myVueDropzoneFile"
                    class="dropzone"
                    :use-custom-slot="true"
                    :options="dropzoneOptions"
                    @vdropzone-success="successResponseFile"
                    @vdropzone-sending="sendingEvent"
                >
                    <div class="dropzone-custom-content">
                        <i class="fas fa-cloud-upload-alt"></i>
                        <h5 class="dropzone-custom-title">Solte o arquivo para importar</h5>
                    </div>
                </vue-dropzone>
            </div>
        </div>
    </cc-modal>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import * as CONSTANTS from "@/constants/constants";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";

export default {
    components: { vueDropzone: vue2Dropzone },
    mixins: [loaderMixin],
    props: {
        client: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            updateDesc: false,
            updateLastPurchase: false,
            updatePacking: false,
            updateInternalCode: false,
            modal: {
                title: `importar produtos`,
                subtitle: `Aqui você importa os produtos do cliente`,
                icon_title: "fas fa-upload",
                cancel_text: "Voltar",
                style: {
                    width: "70%",
                    height: "fit-content",
                },
            },
            dropzoneOptions: {
                url: `${CONSTANTS.API_V3_URL}/admin/clients/${this.client.id}/products/import`,
                timeout: 600000,
                paramName: "file",
                withCredentials: false,
                forceFallback: false,
                headers: this.getHeaders(),
            },
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
        getHeaders() {
            return {
                Authorization: "Bearer " + localStorage.getItem("token"),
                "Cache-Control": null,
            };
        },
        sendingEvent(file, xhr, formData) {
            formData.append("update_desc", this.updateDesc ? 1 : 0);
            formData.append("update_internal_code", this.updateInternalCode ? 1 : 0);
            formData.append("update_last_purchase", this.updateLastPurchase ? 1 : 0);
            formData.append("update_packing", this.updatePacking ? 1 : 0);
        },
        successResponseFile(file, response) {
            this.$emit("success", response);
            this.present_success(
                "Envio concluído com sucesso. Os produtos estão sendo importados e logo estão disponíveis para o cliente!"
            );
            this.close();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./import-products.modal";

.toggle-section {
    width: 100%;
    margin-bottom: 20px;
}

.toggle-section-title {
    font-size: 16px;
    font-weight: 600;
    color: #605f5f;
    margin: 0 0 15px 10px;
}

.toggle-options-container {
    display: flex;
    gap: 30px;
    width: 100%;
    padding: 0 10px;
}

.toggle-option {
    display: flex;
    align-items: center;
    gap: 10px;
}

.toggle-switch {
    position: relative;
    display: inline-block;
    width: 51px;
    height: 31px;
    margin: 0;
}

.toggle-input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.3s;
    border-radius: 31px;
}

.toggle-slider:before {
    position: absolute;
    content: "";
    height: 27px;
    width: 27px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-input:checked + .toggle-slider {
    background-color: #34c759;
}

.toggle-input:focus + .toggle-slider {
    box-shadow: 0 0 1px #34c759;
}

.toggle-input:checked + .toggle-slider:before {
    transform: translateX(20px);
}

.toggle-label {
    font-size: 14px;
    color: #605f5f;
    font-weight: 400;
    user-select: none;
}
</style>
